import { get } from "lodash";
import React, { useMemo } from "react";
import {
	ChipField,
	DateField,
	EditButton,
	List as RaList,
	TextField,
	usePermissions,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import DomainNameField from "./fields/DomainNameField";
import Filters from "./Filters";

const Datagrid = ({ isAdmin, ...props }) => {
	const hasBookmakerTypeFilter = get(props, "filterValues.bookmaker_type_id");
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<DomainNameField source="domain_name" />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					{!hasBookmakerTypeFilter && (
						<ChipField
							source="bookmaker_type.name"
							label="resources.bonus-comparators.fields.bookmaker_type_id"
						/>
					)}
					{isAdmin && (
						<TextField
							source="user.name"
							label="resources.bonus-comparators.fields.user_id"
							style={{ fontWeight: "bold" }}
						/>
					)}
					<DomainNameField source="domain_name" />
					<DateField source="modified" showTime />
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					<EditButton />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasBookmakerTypeFilter && (
				<ChipField
					source="bookmaker_type.name"
					label="resources.bonus-comparators.fields.bookmaker_type_id"
				/>
			)}
			{isAdmin && (
				<TextField
					source="user.name"
					label="resources.bonus-comparators.fields.user_id"
					style={{ fontWeight: "bold" }}
				/>
			)}
			<DomainNameField source="domain_name" />
			<DateField source="modified" showTime />
			<EditButton />
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	const { permissions } = usePermissions();
	const isAdmin = useMemo(
		() => permissions && permissions("admin"),
		[permissions]
	);
	return (
		<RaList
			{...props}
			filters={<Filters isAdmin={isAdmin} />}
			classes={classes}
			perPage={perPage()}
			actions={<Actions />}
			sort={{ field: "modified", order: "desc" }}
			exporter={false}
		>
			<Datagrid isAdmin={isAdmin} />
		</RaList>
	);
};
export default List;
